import { Factory } from '../../services/Factory';
import { ValueType } from './valueType';
import { Utilities } from '../../Utilities';

interface ILiquidGaugeScope extends angular.IScope {
  data: Promise<{ value: number; total: number }>;
  oldData: any;
}

interface ILiquidGaugeAttributes extends angular.IAttributes {
  valueType: string
}

export class LiquidGauge implements angular.IDirective {
  public restrict: string = 'E';
  public link: (scope: ILiquidGaugeScope, element: angular.IAugmentedJQuery, attrs: ILiquidGaugeAttributes) => void;
  public template: string;
  public scope = {data: '=ngModel'};
  public require = ['ngModel'];

  constructor() {
    this.template = "<svg style='width: 250px; height: 323px; display: initial'></svg>";
    this.link = (scope: ILiquidGaugeScope, element: angular.IAugmentedJQuery, attrs: ILiquidGaugeAttributes) => {
        // liquidFillGauge internally does d3.select("#id") to get its SVG root.
        // With replace:true gone, element is the <iio-liquid-gauge> wrapper (HTML),
        // not the template <svg>. We capture the id once, remove it from the wrapper,
        // and re-attach it to a fresh child <svg> on each render so d3 lands in a
        // proper SVG element rather than an HTML element.
        const gaugeId = element.attr('id') || '';
        element.removeAttr('id');

        scope.$watch("data", (newData: any) => {

          if (!newData) {
            return;
          }

          if (!newData || newData.value <= 0 || newData.total <= 0 || (scope.oldData && newData.total == scope.oldData.total)) {
            return;
          }

          let config = {
            minValue: 0,
            maxValue: newData.total + (newData.total * .2),
            circleThickness: 0.05,
            circleFillGap: 0.05,
            circleColor: "#178BCA",
            waveHeight: 0.03,
            waveCount: 1,
            waveRiseTime: 1000,
            waveAnimateTime: 1000,
            waveRise: !scope.oldData,
            waveHeightScaling: true,
            waveAnimate: true,
            waveColor: "#178BCA",
            waveOffset: 0,
            textVertPosition: .5,
            textSize: 0.7,
            valueCountUp: false,
            displayPercent: attrs.valueType == ValueType[ValueType.Percentage],
            textColor: "#045681",
            waveTextColor: "#A4DBf8"
          };

          // Set dimensions on wrapper so it occupies space, then create a
          // fresh <svg> child carrying the gaugeId for d3.select("#id") to find.
          // inline-block lets the parent's text-align:center work (display:block ignores it).
          element.css({display: 'inline-block', width: '250px', height: '323px'});
          element.empty();
          const svgChild = angular.element("<svg style='width: 250px; height: 323px; display: initial'></svg>");
          if (gaugeId) { svgChild.attr('id', gaugeId); }
          element.append(svgChild);

          new liquidFillGauge().loadLiquidFillGauge(svgChild, newData.value, attrs.valueType == ValueType[ValueType.Bytes] ? Utilities.formatBytes(newData.value) : null, config);

          scope.oldData = newData;
        });
    }
  }
}

frontendApp.directive("iioLiquidGauge", [Factory.Create(LiquidGauge)]);
